import { Component } from "react";

import "./SignatureImage.less";

interface IProps {
    url: string | undefined | null;
}

export class SignatureImage extends Component<IProps> {
    render() {
        if (this.props.url === undefined || this.props.url === null) {
            return null;
        }

        return (
            <div className="signatureImage">
                <img src={this.props.url} alt="Signature" />
            </div>
        );
    }
}
